import { render } from "./EditExercise.vue?vue&type=template&id=8af70458"
import script from "./EditExercise.vue?vue&type=script&lang=js"
export * from "./EditExercise.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__